import React from 'react';
import { StyledPlayerLevelImg } from './styles';
import { EBalancesTheme } from 'utils/enums';

interface IPlayerLevelImgProps {
  balanceTheme?: EBalancesTheme;
  playerLevelImg?: string;
}

export const PlayerLevelImg = ({
  balanceTheme = EBalancesTheme.DEFAULT,
  playerLevelImg,
}: IPlayerLevelImgProps) => {
  const isDisplayPlayerLevelImg =
    balanceTheme === EBalancesTheme.GHOST ||
    balanceTheme === EBalancesTheme.ME2ON;

  if (!isDisplayPlayerLevelImg) return null;

  return (
    <StyledPlayerLevelImg className={balanceTheme}>
      <img
        className="player-level-img"
        src={playerLevelImg}
        alt="player level"
      />
    </StyledPlayerLevelImg>
  );
};
